export const getStatusBadgeClass = (status: string): string => {
  const variants = {
    active: 'bg-green-100 text-green-800',
    pending: 'bg-yellow-100 text-yellow-800',
    inactive: 'bg-gray-100 text-gray-800',
    suspended: 'bg-red-100 text-red-800',
  };
  return variants[status as keyof typeof variants] || variants.inactive;
};

export const getRoleBadgeClass = (role: string): string => {
  const variants = {
    super_admin: 'bg-red-100 text-red-800',
    admin: 'bg-blue-100 text-blue-800',
    manager: 'bg-purple-100 text-purple-800',
    staff: 'bg-green-100 text-green-800',
    crew: 'bg-orange-100 text-orange-800',
    client: 'bg-gray-100 text-gray-800',
    vendor: 'bg-indigo-100 text-indigo-800',
  };
  return variants[role as keyof typeof variants] || variants.staff;
};

// Dark-palette badge variants for the redesigned (dark) desktop User
// Management page. The pastel classes above stay for the mobile module.
export const getDarkStatusBadgeClass = (status: string): string => {
  const variants = {
    active: 'bg-[hsl(var(--success))]/15 text-[hsl(var(--success))] border border-[hsl(var(--success))]/30',
    pending: 'bg-amber-500/15 text-amber-500 border border-amber-500/30',
    inactive: 'bg-secondary text-muted-foreground border border-border',
    suspended: 'bg-destructive/15 text-destructive border border-destructive/30',
  };
  return variants[status as keyof typeof variants] || variants.inactive;
};

export const getDarkRoleBadgeClass = (_role: string): string => {
  return 'bg-primary/10 text-primary border border-primary/30';
};

export const getInitials = (name: string): string => {
  return name
    .split(' ')
    .map(n => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
};

export const generateCSV = (data: any[]): string => {
  if (!data.length) return '';
  
  const headers = Object.keys(data[0]).join(',');
  const rows = data.map(row => 
    Object.values(row).map(value => 
      typeof value === 'string' ? `"${value.replace(/"/g, '""')}"` : value
    ).join(',')
  );
  
  return [headers, ...rows].join('\n');
};

export const downloadCSV = (content: string, filename: string): void => {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};